<template>
  <div class="c-list-box">
    <ul
      style="
        border: 1px solid var(--el-border-color-lighter);
        border-bottom: 0;
        padding: 10px;
        font-size: 13px;
        display: flex;
        align-items: center;
      "
    >
      <li style="flex: 1">
        当前已选择：<strong
          style="color: #1e90ff; margin: 0 5px; font-size: 140%"
          >{{ state.select_ids?.length || 0 }}</strong
        >人
      </li>
      <el-button
        type="danger"
        icon="Delete"
        @click="
          state.select_ids = [];
          state.key = Math.random();
        "
        >清空已选
      </el-button>
      <el-button type="success" icon="Select" @click="onConfirm"
        >完成选择
      </el-button>
    </ul>
    <ul class="c-list-search" style="margin-top: 0">
      <el-radio-group v-model="state.params.status" @change="onLoad">
        <el-radio-button>全部</el-radio-button>
        <el-radio-button :value="1">正常</el-radio-button>
        <el-radio-button :value="0">停用</el-radio-button>
      </el-radio-group>
      <el-input
        v-model="state.params.keywords"
        style="width: 300px"
        placeholder="姓名、电话、身份证号"
        clearable
        @clear="
          delete state.params.keywords;
          onLoad();
        "
        @paste.enter="$onKeywordsPaste($event, state.params)"
      ></el-input>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @row-click="onRowClick"
        @sort-change="onSortChange"
      >
        <el-table-column width="55" label="序号" fixed>
          <template #default="{ row }">
            <el-checkbox
              :checked="state.select_ids?.includes(row.id)"
              :key="state.key"
              @change.stop="onSelectChange(row, $event)"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          :formatter="
            (row, column, cellValue) =>
              $tab_Highlinght(cellValue, state.params.keywords)
          "
        />
        <el-table-column prop="phone" label="手机号">
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="手机号"
              @click="$onCopy(row.phone)"
            >
              {{ row.phone }}
            </text>
          </template>
        </el-table-column>
        <el-table-column prop="idcard" label="证件号">
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="证件号"
              @click="$onCopy(row.idcard)"
            >
              {{ row.idcard }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          :formatter="
            (row) =>
              $statusFormat({
                Text: row.status == 0 ? '停用' : '正常',
                Color: row.status == 0 ? '#f00' : '#1e90ff',
              })
          "
        />
        <el-table-column prop="sex" label="性别" align="center">
          <template #default="{ row }">
            <text v-if="row.sex == '男'" style="color: #1e90ff">男</text>
            <text v-else-if="row.sex == '女'" style="color: #f00">女</text>
            <text v-else>-</text>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { taxdeclarecorrect_withholdingagent_employee_list } from "@/http/taxdeclarecorrect";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}

export default {
  props: {
    withholding_agent_id: Number,
    select_ids: Array,
  },
  setup(props, { emit }) {
    const state = reactive({
      ...new InitFormData(),
      select_ids: [],
      select_arr: [],
    });
    onMounted(() => {
      state.params.withholding_agent_id = props.withholding_agent_id;
      state.select_ids = props.select_ids || [];

      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      taxdeclarecorrect_withholdingagent_employee_list(state.params).then(
        (res) => {
          if (res.status == 200) {
            const { count, list } = res.data.data;
            state.tableData = list;
            state.totalCount = count;
            state.key = Math.random();
          }
        }
      );
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      delete state.withholding_agent_uid;
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //表格行点击事件
    const onRowClick = (row) => {
      if (state.select_ids.includes(row.id)) {
        state.select_ids = state.select_ids.filter((w) => w != row.id);
        state.select_arr = state.select_arr.filter((w) => w.id != row.id);
      } else {
        state.select_ids.push(row.id);
        state.select_arr.push(row);
      }
      state.key = Math.random();
    };

    const onSelectChange = (item, checked) => {
      if (checked) {
        state.select_ids.push(item.id);
        state.select_arr.push(item);
      } else {
        state.select_ids = state.select_ids.filter((w) => w != item.id);
        state.select_arr = state.select_arr.filter((w) => w.id != item.id);
      }
      state.key = Math.random();
    };

    const onConfirm = () => {
      emit("confirm", { ids: state.select_ids, arr: state.select_arr });
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onSelectChange,
      onRowClick,
      onConfirm,
    };
  },
};
</script>
<style></style>
